module.exports = __webpack_public_path__ + "img/prepare-lesson-down.2ae4a6ba.svg";